<template>
	<div class="h-panel-body padding font-bold">
		<Row :space="9">
			<Cell width="6" v-for="(type,i) in typeList" :key="i">
				<div>
					<p>{{type.name}}</p>
					<p class="pnumber" v-if="money[type.code] && (money[type.code].debitAmount||money[type.code].creditAmount)">{{money[type.code].debitAmount||money[type.code].creditAmount|numFormat}}</p>
					<p class="pnumber" v-else>0.00</p>
					<router-link v-if="money[type.code]" tag="button" :to="{name:'VoucherForm', params: { voucherId: money[type.code].voucherId}}" class="h-btn h-btn-green">查看凭证</router-link>
					<router-link v-else tag="button" :to="{name:'VoucherForm', params: { checkData,type }}" class="h-btn h-btn-primary">生成凭证</router-link>
				</div>
			</Cell>
			<Cell width="6">
				<div>
					<p>自定义结转模板</p>
					<p class="pnumber">按模板配置结转</p>
					<button class="h-btn h-btn-primary" @click="openTplList">管理模板</button>
				</div>
			</Cell>
		</Row>
		<div align="center" style="margin-top: 20px;">
			<button class="h-btn h-btn-text-primary h-btn-transparent" @click="back">上一步</button>
			<button class="h-btn h-btn-primary" @click="check">下一步</button>
		</div>

		<!-- 自定义结转模板列表 -->
		<Modal v-model="showTplList">
			<div slot="header">自定义结转模板（{{checkYear}}年{{checkMonth}}期）</div>
			<div class="padding">
				<table class="grid">
					<thead>
					<tr>
						<th>模板名称</th><th>凭证字</th><th>结转金额</th><th>凭证</th><th>操作</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="tpl in tplList" :key="tpl.id">
						<td>{{tpl.title}}</td>
						<td>{{tpl.voucherWord}}</td>
						<td align="right">{{tpl.amount|numFormat}}</td>
						<td>
							<template v-if="tpl.voucherIds && tpl.voucherIds.length">已生成</template>
							<template v-else>未生成</template>
						</td>
						<td>
							<button v-if="tpl.voucherIds && tpl.voucherIds.length" class="h-btn h-btn-green text-blue" style="padding: 0 8px" @click="viewVoucher(tpl)">查看凭证</button>
							<button v-else class="h-btn h-btn-primary" style="padding: 0 8px" @click="executeTpl(tpl)">生成凭证</button>
							<button class="h-btn h-btn-text-primary" style="padding: 0 8px" @click="editTpl(tpl.id)">编辑</button>
							<button class="h-btn h-btn-text-primary" style="padding: 0 8px" @click="deleteTpl(tpl)">删除</button>
						</td>
					</tr>
					<tr v-if="!tplList.length">
						<td colspan="5" align="center">暂无模板，点击下方按钮新增</td>
					</tr>
					</tbody>
				</table>
				<div class="text-center margin-top">
					<Button color="green" @click="editTpl(null)" :loading="tplLoading">新增模板</Button>
					<Button @click="showTplList=false">关闭</Button>
				</div>
			</div>
		</Modal>

		<!-- 模板编辑 -->
		<Modal v-model="showTplEdit" :hasCloseIcon="true">
			<div slot="header">{{tplForm.id ? '编辑' : '新增'}}结转模板</div>
			<div class="padding">
				<div class="flex" style="gap: 16px">
					<div class="flex-item">
						<label class="required">名称</label>
						<input type="text" v-model="tplForm.title" placeholder="模板名称">
					</div>
					<div>
						<label class="required">凭证字</label>
						<Select v-model="tplForm.voucherWordId" :datas="voucherWords" keyName="id" titleName="word" style="width: 120px"/>
					</div>
				</div>
				<div class="margin-top">结转明细</div>
				<table class="grid">
					<thead>
					<tr>
						<th style="width: 30px"></th>
						<th>摘要</th>
						<th style="width: 220px">科目</th>
						<th style="width: 120px">取值</th>
						<th style="width: 110px">平衡比率(%)</th>
						<th style="width: 70px">方向</th>
						<th style="width: 130px">操作</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(item, idx) in tplForm.items" :key="idx">
						<td align="center">
							<i class="fa fa-plus-circle text-hover" @click="addItem(idx)"></i>
							<i v-if="tplForm.items.length > 2" class="fa fa-minus-circle text-hover" style="margin-left: 4px" @click="delItem(idx)"></i>
						</td>
						<td><input type="text" v-model="item.summary" placeholder="摘要"></td>
						<td>
							<Select v-model="item.subjectId" :datas="subjectOptions" keyName="id" :titleName="'label'" filterable :deletable="false" placeholder="请选择科目" @change="itemSubjectChange(item)"></Select>
						</td>
						<td>
							<Select v-model="item.valueType" :datas="valueTypes" keyName="key" titleName="title" :deletable="false" @change="valueTypeChange(item)"></Select>
						</td>
						<td>
							<NumberInput v-model="item.eqRate" :disabled="item.valueType === '按公式取值'" :precision="4" style="width: 100px"></NumberInput>
						</td>
						<td>
							<Select v-model="item.balanceDirection" :datas="directions" keyName="key" titleName="title" :deletable="false"></Select>
						</td>
						<td>
							<button v-if="item.valueType === '按公式取值'" class="h-btn h-btn-text-primary" style="padding: 0 6px" @click="openRules(item)">公式({{(item.rules || []).length}})</button>
						</td>
					</tr>
					</tbody>
				</table>
				<div v-if="tplEditError" style="color:#e64c4c" class="margin-top">{{tplEditError}}</div>
				<div class="text-gray margin-top" style="font-size: 12px">「自动平衡」项按差额×平衡比率倒挤，各行平衡比率合计须为 100%；「按公式取值」项按取数公式计算（科目期末余额×取值比率，可加减）。</div>
			</div>
			<div class="text-center">
				<Button color="green" @click="saveTpl" :loading="tplLoading">保存</Button>
				<Button @click="showTplEdit=false">取消</Button>
			</div>
		</Modal>

		<!-- 取数公式编辑 -->
		<Modal v-model="showRuleEdit" :hasCloseIcon="true">
			<div slot="header">取数公式 - {{ruleItem ? (ruleItem.subjectName || '') : ''}}</div>
			<div class="padding">
				<table class="grid">
					<thead>
					<tr>
						<th style="width: 30px"></th>
						<th style="width: 260px">科目</th>
						<th style="width: 80px">运算符</th>
						<th style="width: 110px">取值比率(%)</th>
						<th>取数规则</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(rule, idx) in (ruleItem ? ruleItem.rules : [])" :key="idx">
						<td align="center">
							<i class="fa fa-plus-circle text-hover" @click="addRule(idx)"></i>
							<i v-if="ruleItem && ruleItem.rules.length > 1" class="fa fa-minus-circle text-hover" style="margin-left: 4px" @click="delRule(idx)"></i>
						</td>
						<td>
							<Select v-model="rule.subjectId" :datas="subjectOptions" keyName="id" :titleName="'label'" filterable :deletable="false" placeholder="请选择科目" @change="ruleSubjectChange(rule)"></Select>
						</td>
						<td>
							<Select v-model="rule.operator" :datas="operators" keyName="key" titleName="title" :deletable="false"></Select>
						</td>
						<td>
							<NumberInput v-model="rule.rate" :precision="4" style="width: 100px"></NumberInput>
						</td>
						<td>余额</td>
					</tr>
					</tbody>
				</table>
			</div>
			<div class="text-center">
				<Button color="green" @click="showRuleEdit=false">确定</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import StringUtils from 'string-utilz';

	export default {
		name: "checkout",
		props: {
			checkYear: [Number, String],
			checkMonth: [Number, String],
		},
		computed: {
			...mapState(['currentAccountSets']),
			typeList() {
				let isQy = this.currentAccountSets.accountingStandards === 0;
				return [
					{
						code: isQy ? '5401' : '6401',
						type: 'jzxscb',
						name: '结转销售成本',
						subject: isQy ? [5401, 1405] : [6401, 1405]
					},
					{
						code: '2211',
						type: 'jtzgxc',
						name: '计提职工薪酬',
						subject: isQy ? [this.codeConversion(560201), this.codeConversion(560101), 2211] : [this.codeConversion(660201), this.codeConversion(660101), 2211]
					},
					{
						code: '1602',
						type: 'jtzj',
						name: '计提折旧',
						subject: isQy ? [this.codeConversion(560207), 1602] : [this.codeConversion(660207), this.codeConversion(660107), 1602]
					},
					{
						code: '1801',
						type: 'txdtfy',
						name: '摊销待摊费用',
						subject: isQy ? [this.codeConversion(560212), 1801] : [this.codeConversion(660212), 1801]
					},
					{
						code: isQy ? '5401' : '6403',
						type: 'jtsj',
						name: '计提税金',
						subject: isQy ? [5403, this.codeConversion(222108), this.codeConversion(222113), this.codeConversion(222114)] : [6403, this.codeConversion(222108), this.codeConversion(222113), this.codeConversion(222114)]
					},
					{
						code: this.codeConversion('222102'),
						type: 'jzwjzzs',
						name: '结转未交增值税',
						subject: [this.codeConversion(22210103), this.codeConversion(222102)]
					},
					{
						code: isQy ? '5401' : '6801',
						type: 'jtsds',
						name: '计提所得税',
						subject: isQy ? [5801, this.codeConversion(222106)] : [6801, this.codeConversion(222106)]
					},
					{
						code: isQy ? '3103' : '4103',
						type: 'jzsy',
						name: '结转损益',
						subject: isQy ? [3103] : [4103]
					}
				]
			}
		},
		data() {
			return {
				selected: 'carry-forward',
				checkData: {},
				money: {},
				// 自定义结转模板
				showTplList: false,
				showTplEdit: false,
				showRuleEdit: false,
				tplLoading: false,
				tplList: [],
				tplForm: {id: null, title: '', voucherWordId: null, items: []},
				tplEditError: '',
				voucherWords: [],
				subjectOptions: [],
				ruleItem: null,
				valueTypes: [{key: '自动平衡', title: '自动平衡'}, {key: '按公式取值', title: '按公式取值'}],
				directions: [{key: '借', title: '借'}, {key: '贷', title: '贷'}],
				operators: [{key: '+', title: '+'}, {key: '-', title: '-'}]
			}
		},
		methods: {
			check() {
				this.$router.push({name: 'Check', params: this.checkData})
			},
			back() {
				this.$router.back()
			},
			init() {
				this.$api.voucher.carryForwardMoney({
					years: this.checkYear,
					month: this.checkMonth,
					code: this.typeList.map(val => val.code)
				}).then(({data}) => {
					this.money = data;
				});
			},
			// ================= 自定义结转模板 =================
			openTplList() {
				this.showTplList = true;
				this.loadTplList();
			},
			loadTplList() {
				this.tplLoading = true;
				this.$api.checkout.templateList({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
					this.tplList = data || [];
				}).finally(() => {
					this.tplLoading = false;
				});
			},
			initTplBase() {
				if (!this.voucherWords.length) {
					this.$api.setting.voucherWord.list().then(({data}) => {
						this.voucherWords = data || [];
						if (!this.tplForm.voucherWordId && this.voucherWords.length) {
							let def = this.voucherWords.find(v => v.isDefault) || this.voucherWords[0];
							this.tplForm.voucherWordId = def.id;
						}
					});
				}
				if (!this.subjectOptions.length) {
					this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
						this.subjectOptions = (data || []).map(s => ({
							id: s.id, code: s.code, name: s.name, fullName: s.fullName || s.name,
							balanceDirection: s.balanceDirection,
							label: `${s.code}-${s.fullName || s.name}(${s.balanceDirection || ''})`
						}));
					});
				}
			},
			emptyItem() {
				return {subjectId: null, subjectCode: null, subjectName: null, balanceDirection: '借', valueType: '自动平衡', summary: '', eqRate: 100, rules: []};
			},
			addItem(idx) {
				this.tplForm.items.splice(idx + 1, 0, this.emptyItem());
			},
			delItem(idx) {
				this.tplForm.items.splice(idx, 1);
			},
			itemSubjectChange(item) {
				let s = this.subjectOptions.find(v => v.id === item.subjectId);
				if (s) {
					item.subjectCode = s.code;
					item.subjectName = `${s.code}-${s.name}`;
					if (item.valueType === '按公式取值' && (!item.rules || !item.rules.length)) {
						item.rules = [{subjectId: s.id, subjectCode: s.code, subjectName: item.subjectName, operator: '+', valueType: '余额', rate: 100}];
					}
				}
			},
			valueTypeChange(item) {
				if (item.valueType === '按公式取值') {
					item.eqRate = null;
					if (!item.rules || !item.rules.length) {
						item.rules = [{subjectId: item.subjectId, subjectCode: item.subjectCode, subjectName: item.subjectName, operator: '+', valueType: '余额', rate: 100}];
					}
				} else {
					item.rules = [];
					if (item.eqRate == null) item.eqRate = 100;
				}
			},
			openRules(item) {
				this.ruleItem = item;
				this.showRuleEdit = true;
			},
			addRule(idx) {
				this.ruleItem.rules.splice(idx + 1, 0, {subjectId: null, subjectCode: null, subjectName: null, operator: '+', valueType: '余额', rate: 100});
			},
			delRule(idx) {
				this.ruleItem.rules.splice(idx, 1);
			},
			ruleSubjectChange(rule) {
				let s = this.subjectOptions.find(v => v.id === rule.subjectId);
				if (s) {
					rule.subjectCode = s.code;
					rule.subjectName = `${s.code}-${s.name}`;
				}
			},
			editTpl(id) {
				this.tplEditError = '';
				this.initTplBase();
				if (id == null) {
					this.tplForm = {id: null, title: '', voucherWordId: null, items: [this.emptyItem(), Object.assign(this.emptyItem(), {balanceDirection: '贷', eqRate: 0})]};
					this.showTplList = false;
					this.showTplEdit = true;
					return;
				}
				this.$api.checkout.templateData({id}).then(({data}) => {
					let items = [];
					try {
						items = JSON.parse(data.items || '[]');
					} catch (e) {
						items = [];
					}
					this.tplForm = {id: data.id, title: data.title, voucherWordId: data.voucherWordId, items: items};
					this.showTplList = false;
					this.showTplEdit = true;
				});
			},
			saveTpl() {
				this.tplEditError = '';
				if (!this.tplForm.title || !this.tplForm.title.trim()) {
					this.tplEditError = '请填写模板名称';
					return;
				}
				if (this.tplForm.items.some(it => !it.subjectId)) {
					this.tplEditError = '请为每行结转明细选择会计科目';
					return;
				}
				let eqSum = 0;
				this.tplForm.items.forEach(it => {
					if (it.valueType === '自动平衡') eqSum += Number(it.eqRate) || 0;
				});
				if (eqSum > 0 && Math.abs(eqSum - 100) > 0.0001) {
					this.tplEditError = '各项自动平衡合计必须为100%';
					return;
				}
				this.tplLoading = true;
				this.$api.checkout.saveTemplate({
					id: this.tplForm.id,
					title: this.tplForm.title,
					voucherWordId: this.tplForm.voucherWordId,
					items: JSON.stringify(this.tplForm.items)
				}).then(() => {
					this.$Message('保存成功');
					this.showTplEdit = false;
					this.showTplList = true;
					this.loadTplList();
				}).finally(() => {
					this.tplLoading = false;
				});
			},
			deleteTpl(tpl) {
				this.$Confirm(`确认删除模板【${tpl.title}】?`).then(() => {
					this.$api.checkout.deleteTemplate(tpl.id).then(() => {
						this.$Message('删除成功');
						this.loadTplList();
					});
				});
			},
			executeTpl(tpl) {
				this.tplLoading = true;
				this.$api.checkout.executeTemplate({id: tpl.id, year: this.checkYear, month: this.checkMonth}).then(() => {
					this.$Message('结转凭证已生成');
					this.loadTplList();
				}).finally(() => {
					this.tplLoading = false;
				});
			},
			viewVoucher(tpl) {
				this.showTplList = false;
				this.$router.push({name: 'VoucherForm', params: {voucherId: tpl.voucherIds[0]}});
			},
			// ================= 固定结转卡片 =================
			codeConversion(code) {
				code = String(code);
				let encoding = this.currentAccountSets.encoding.split('-');
				let reg = RegExp(`^\\d{4}(\\d{${encoding[1]}|\\d{${encoding[1]}\\d{${encoding[2]}|\\d{${encoding[1]}\\d{${encoding[2]}\\d{${encoding[3]})$`);
				if (!reg.test(code)) {
					code = this.updateCode(code, [4, 2, 2, 2], encoding);
				}
				return code;
			},
			updateCode(code, model, newModel) {
				let codeSp = [];
				let start = 0;
				for (let i in model) {
					let len = model[i];
					if (code.length <= start) {
						break;
					}
					codeSp.push(code.substring(start, Math.min(code.length, start + len)));
					start += len;
				}

				for (let i = 0; i < codeSp.length; i++) {
					let item = codeSp[i];
					let len = parseInt(newModel[i]);
					if (item) {
						if (item.length < len) {
							item = StringUtils.pad(item, item.length - len, "0");
						} else if (item.length > len) {
							item = item.substring(item.length - len);
						}
						codeSp[i] = item;
					}
				}

				return codeSp.join("");
			}
		},
		mounted() {
			this.checkData = {checkYear: this.checkYear, checkMonth: this.checkMonth};
			this.init();
		}
	}
</script>

<style lang="less" scoped>
	.h-row > div > div {
		padding: 8px;
		color: #000;
		border-radius: 3px;
		text-align: center;
		background-color: #Fff;
		height: 150px;
		line-height: 36px;
		border: 1px solid #eee;
	}

	.pnumber {
		margin: 5px 0;
		font-size: larger;
	}

	table.grid {
		width: 100%;
		border-collapse: collapse;
		font-weight: normal;

		th, td {
			border: 1px solid #eee;
			padding: 6px 8px;
			font-weight: normal;
		}

		th {
			background: #f5f7fa;
		}
	}

	.fa-plus-circle, .fa-minus-circle {
		cursor: pointer;
		color: #3b91ff;
	}

	.fa-minus-circle {
		color: #e64c4c;
	}
</style>
